import type { ListBuilderList } from '../../../types';

/**
 * Pending PO list configuration
 * Shows requests with vendor identified, pending PO
 */
export const pendingPoList: ListBuilderList = {
	id: 'default-sourcing-requests-pending-po',
	cacheTTL: 300000,
	name: 'Pending PO',
	type: 'default',
	active: true,
	sortOrder: 7,
	filterRules: {
		sourcingRequestAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
		},
		sourcingRequestLineStatus: {
			defaultValue: [{ id: 'vendor_identified', label: 'Vendor Identified' }],
			locked: true,
			hidden: true,
		},
	},
	inheritsFrom: 'default-sourcing-requests-all',
};
